export default __webpack_public_path__ + "static/media/Entropy.af5b1ad0.jpg";